import React from 'react'
import BaseIcon from 'react-icon-base'

const CheckMark = props => (
  <BaseIcon width="13" height="10" viewBox="0 0 13 10" {...props}>
    <path
      fill="#2ED8A7"
      fillRule="evenodd"
      d="M5.762 9.558l6.804-6.983a1.528 1.528 0 0 0 0-2.133 1.463 1.463 0 0 0-2.095 0L4.66 6.415l-2.13-2.169a1.463 1.463 0 0 0-2.095 0 1.528 1.528 0 0 0 0 2.133l3.033 3.09c.16.163.349.28.55.354.56.305 1.272.216 1.745-.265z"
    />
  </BaseIcon>
)

export default CheckMark
